const WHATSAPP_HREF = 'https://wa.me/5511989082892';

export function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP_HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com a Educa Legal pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 transition-transform duration-200 hover:scale-105 hover:bg-[#1ebe57] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="currentColor"
        className="h-7 w-7"
        aria-hidden="true"
      >
        <path d="M16.001 3C9.373 3 4 8.373 4 15.001c0 2.49.778 4.79 2.103 6.69L4 29l7.49-1.97A11.94 11.94 0 0 0 16 27.001C22.628 27.001 28 21.628 28 15.001 28 8.373 22.628 3 16.001 3Zm0 21.6a9.59 9.59 0 0 1-4.882-1.34l-.35-.207-4.443 1.168 1.184-4.328-.228-.354A9.6 9.6 0 1 1 16.001 24.6Zm5.49-7.197c-.301-.151-1.78-.879-2.057-.98-.276-.1-.477-.15-.678.152-.2.301-.778.98-.954 1.181-.175.2-.351.226-.652.075-.301-.15-1.272-.469-2.421-1.496-.895-.799-1.499-1.787-1.674-2.088-.176-.301-.019-.464.132-.614.135-.135.301-.351.452-.527.151-.176.2-.301.301-.502.1-.2.05-.376-.025-.527-.075-.15-.677-1.634-.928-2.235-.245-.589-.494-.509-.677-.518-.176-.008-.376-.01-.577-.01-.2 0-.527.075-.803.377-.276.301-1.053 1.028-1.053 2.507 0 1.48 1.078 2.91 1.228 3.111.15.2 2.122 3.238 5.142 4.541.719.31 1.279.495 1.716.633.721.229 1.378.197 1.897.12.579-.086 1.78-.727 2.031-1.429.251-.703.251-1.305.176-1.43-.075-.125-.276-.2-.577-.351Z" />
      </svg>
    </a>
  );
}
